/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserId
 */
export interface UserId {
    /**
     * 
     * @type {string}
     * @memberof UserId
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof UserId
     */
    username?: string;
}

/**
 * Check if a given object implements the UserId interface.
 */
export function instanceOfUserId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserIdFromJSON(json: any): UserId {
    return UserIdFromJSONTyped(json, false);
}

export function UserIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}

export function UserIdToJSON(value?: UserId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenant': value.tenant,
        'username': value.username,
    };
}

